const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_URL = API_URL.replace('/api/', '/admin/');

export const PATHS = {
    admin: {
        getUsers: () => `${ADMIN_URL}users`,
        saveCompanyStatus: (id) => `${ADMIN_URL}companies/${id}/status`,
        saveUserStatus: (id) => `${ADMIN_URL}users/${id}/status`
    },
    app: {
        sendRecommendation: () => `${API_URL}recommendations`
    },
    auth: {
        login: () => `${API_URL}login`,
        forgotPassword: () => `${API_URL}forgot-password`,
        sendRequestInvitation: () => `${API_URL}invitation-requests`,
        resetPassword: () => `${API_URL}reset-password`
    },
    company: {
        create: () => `${API_URL}companies`,
        getById: (companyId) => `${API_URL}companies/${companyId}`,
        save: (companyId) => `${API_URL}companies/${companyId}`,
        savePaymentMethod: (companyId) => `${API_URL}companies/${companyId}/billing/payment_method`,
        saveSubscription: (companyId) => `${API_URL}companies/${companyId}/billing/subscription`
    },
    enumerations: {
        getAllIndustryExperienceTypes: () => `${API_URL}industry-experiences`,
        getAllLocations: () => `${API_URL}locations`,
        getAllSkills: () => `${API_URL}skills`,
        getAllSpecialties: () => `${API_URL}specializations`
    },
    file: {
        getUploadUrl: (filename) => `${API_URL}users/me/upload-profile-pic?filename=${filename}`
    },
    messages: {
        createConversation: () => `${API_URL}conversations`,
        getAllConversations: () => `${API_URL}conversations`,
        getMessagesInConversation: (conversationId) => `${API_URL}conversations/${conversationId}/messages`,
        markConversationAsRead: (conversationId) => `${API_URL}conversations/${conversationId}/mark_read`,
        sendMessageInConversation: (conversationId) => `${API_URL}conversations/${conversationId}/messages`
    },
    opportunity: {
        create: () => `${API_URL}postings`,
        delete: (opportunityId) => `${API_URL}postings/${opportunityId}/delete`,
        getById: (opportunityId) => `${API_URL}postings/${opportunityId}`,
        getForCompany: (companyId) => `${API_URL}postings/company/${companyId}`,
        save: (postingId) => `${API_URL}postings/${postingId}`,
        search: (searchTerm, specializationIds, experienceIds) => `${API_URL}postings?${searchTerm ? `search=${searchTerm}` : ''}${specializationIds ? `&specializationIds=${specializationIds}` : ''}${experienceIds ? `&experienceIds=${experienceIds}` : ''}`
    },
    freelancer: {
        search: (searchTerm, specializationIds, experienceIds) => `${API_URL}users?${searchTerm ? `search=${searchTerm}` : ''}${specializationIds ? `&specializationIds=${specializationIds}` : ''}${experienceIds ? `&experienceIds=${experienceIds}` : ''}`
    },
    user: {
        adminCreate: () => `${ADMIN_URL}users`,
        create: () => `${API_URL}users`,
        getById: (userId) => `${API_URL}users/${userId}`,
        getLoggedIn: () => `${API_URL}users/me`,
        save: (userId) => `${API_URL}users/${userId || 'me'}`
    }
};




// WEBPACK FOOTER //
// ./src/utils/paths.js